// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_1EvJH","visible":"bbXEX","collapsed":"_2yDUf"};